import React from "react";
import { Link } from "react-router-dom";
import { BsLinkedin, BsGithub, BsYoutube, BsInstagram } from "react-icons/bs";
import newsletter from "../images/newsletter.png";
const Footer = () => {
  return (
    <>
    
 <footer className="text-white py-4" style={{ background: "#0053e2", fontSize: "14px" }}>
  <div className="container-xxl">
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-3">
      {/* Contact Us */}
      <div className="col-6 col-md-3">
        <h6 className="fw-bold mb-2">Contact Us</h6>
    <a
  href="mailto:info@shoplintic.in"
  className="text-link text-white small mb-1 d-inline-block"
>
  info@shoplintic.in
</a>

<a
  href="tel:+918583864755"
  className="text-link text-white small d-inline-block"
>
  Mobile: +91 8583864755
</a>

      
      </div>

      {/* Policies */}
      <div className="col-6 col-md-3">
        <h6 className="fw-bold mb-2">Policies</h6>
        <div className="d-flex flex-column small">
          <Link to="/privacy-policy" className="text-white mb-1" style={{minHeight:"0px"}}>Privacy Policy</Link>
          <Link to="/refund-policy" className="text-white mb-1" style={{minHeight:"0px"}}>Refund Policy</Link>
          <Link to="/shipping-policy" className="text-white mb-1" style={{minHeight:"0px"}}>Shipping Policy</Link>
          <Link to="/term-conditions" className="text-white mb-1" style={{minHeight:"0px"}}>Terms & Conditions</Link>
        </div>
      </div>

      {/* Company */}
      <div className="col-6 col-md-3">
        <h6 className="fw-bold mb-2">Company</h6>
        <div className="d-flex flex-column small">
          <Link to="/about" className="text-white mb-1" style={{minHeight:"0px"}}>About Us</Link>
          <Link to="/blogs" className="text-white mb-1" style={{minHeight:"0px"}}>Blog</Link>
          <Link to="/contact" className="text-white mb-1" style={{minHeight:"0px"}}>Contact</Link>
        </div>
      </div>

      {/* Quick Links */}
      <div className="col-6 col-md-3">
        <h6 className="fw-bold mb-2">Quick Links</h6>
        <div className="d-flex flex-column small">
          <Link to="/product?tag=new_arrival" className="text-white mb-1" style={{minHeight:"0px"}}>New Arrivals</Link>
          <Link to="/product?tag=best_seller" className="text-white mb-1" style={{minHeight:"0px"}}>Best Seller</Link>
          <Link to="/product?tag=now_trending" className="text-white mb-1" style={{minHeight:"0px"}}>Now Trending</Link>
        </div>
      </div>
    </div>
  </div>
</footer>

{/* Bottom Footer */}
<footer className="text-white py-2" style={{ background: "#0053e2", fontSize: "13px" }}>
  <div className="container-xxl text-center">
    <p className="mb-0">&copy; {new Date().getFullYear()} Powered by shoplintic</p>
  </div>
</footer>


    </>
  );
};

export default Footer;
